import React from "react";
import { Box, Typography, useTheme } from "@mui/material";

export default function CampaignDetailsCard({
  value,
  label,
}: {
  value: React.ReactNode;
  label: string;
}) {
  const theme = useTheme();
  return (
    <Box
      sx={{
        p: 3,
        backgroundColor: theme.palette.background.paper,
        boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.04)",
        borderRadius: 2,
        border: `1px solid ${theme.palette.neutral[200]}`,
        display: "flex",
        flexDirection: "column",
        gap: 2,
        height: "100%",
      }}
    >
      <Typography
        variant="h3"
        sx={{ color: theme.palette.primary.main, fontWeight: 700 }}
      >
        {value}
      </Typography>
      <Typography
        variant="body2"
        sx={{
          color: theme.palette.primary.main,
          fontFamily: "Nunito",
          fontWeight: 400,
        }}
      >
        {label}
      </Typography>
    </Box>
  );
}
